import React, { FC } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const { Content } = Layout;

interface OverviewShellTab {
	key: string;
	name: string;
	accessPermissionName?: string;
	// Rendered greyed out and non-navigable — for surfaces that aren't available yet.
	disabled?: boolean;
}

interface OverviewShellProps {
	title: string;
	tabs: OverviewShellTab[];
	onTabChange: (key: string) => void;
	checkTabActive: (key: string) => boolean;
	childRoutes: any[];
	className?: string;
	tabsRightActions?: () => React.ReactNode;
	tabsClassName?: string;
	headerRightContent?: React.ReactNode;
	hideTabs?: boolean;
	navblockColor?: string;
	creationRoutes?: string[];
	// injected by withRouter — always present at runtime
	history?: any;
	companyConfig?: any;
}

const OverviewShell: FC<OverviewShellProps> = ({
	title,
	tabs,
	onTabChange,
	checkTabActive,
	childRoutes,
	className,
	tabsRightActions,
	tabsClassName,
	headerRightContent,
	hideTabs,
	navblockColor,
	creationRoutes = ['new'],
	history,
	companyConfig,
}) => {
	const pathname = history.location.pathname;
	const trimmedPathname = pathname.replace(/\/+$/, '');
	const pathnameParts = trimmedPathname.split('/');
	const lastPathnamePart = pathnameParts[pathnameParts.length - 1] || '';
	const shouldHideTabs =
		hideTabs !== undefined ? hideTabs : creationRoutes.includes(lastPathnamePart);
	const resolvedNavblockColor =
		navblockColor ||
		nullSafeGet('detail.config.theme.navblock', companyConfig) ||
		nullSafeGet('config.theme.navblock', companyConfig);

	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Content className={className} style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: shouldHideTabs ? 24 : 0,
							background: resolvedNavblockColor,
							marginBottom: 8,
						}}
					>
						{headerRightContent ? (
							<div className="flex flex-row items-center justify-between">
								<h4
									style={{
										color: 'rgba(255, 255, 255, 0.9)',
										marginRight: 8,
										marginBottom: shouldHideTabs ? 0 : 24,
									}}
								>
									{title}
								</h4>
								{headerRightContent}
							</div>
						) : (
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: shouldHideTabs ? 0 : 24,
								}}
							>
								{title}
							</h4>
						)}
						{shouldHideTabs ? null : (
							<SubnavTabs
								tabs={tabs}
								onChange={onTabChange}
								isActive={checkTabActive}
								tabsRightActions={tabsRightActions}
								className={tabsClassName}
							/>
						)}
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: (state as any).company_config,
});

export default withRouter<any, any>(connect(mapStateToProps)(OverviewShell) as any);
